import { render, staticRenderFns } from "./detail-delivery.vue?vue&type=template&id=0619e4b4&scoped=true"
import script from "./detail-delivery.vue?vue&type=script&lang=js"
export * from "./detail-delivery.vue?vue&type=script&lang=js"
import style0 from "./detail-delivery.vue?vue&type=style&index=0&id=0619e4b4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0619e4b4",
  null
  
)

export default component.exports